import { Product } from "@deliverr/commons-clients";

export const getProductIsLotTrackingEnabled = ({ isLotTrackingEnabled }: Product): boolean => !!isLotTrackingEnabled;
